import { render, staticRenderFns } from "./Especialista2.vue?vue&type=template&id=d91e2d64"
import script from "./Especialista2.vue?vue&type=script&lang=js"
export * from "./Especialista2.vue?vue&type=script&lang=js"
import style0 from "./Especialista2.vue?vue&type=style&index=0&id=d91e2d64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports